import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Stack,
} from '@mui/material';
import { DialogTitleClose, PaperComponent } from '../dialog';
import { FormInputText } from '../form';
import * as subMatFolderAlarmEmailActions from '../../store/subMatFolderAlarmEmail';

const EMPTY_SLOTS = [
  { period: 0, type: 'D' },
  { period: 0, type: 'D' },
  { period: 0, type: 'D' },
];

const spinnerStyles = {
  '-webkit-appearance': 'none',
  background: "#fff url('spinner.png') no-repeat center center",
  width: '2em',
  opacity: 1,
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  overflow: 'hidden',
  borderTopRightRadius: '0.25rem',
  borderBottomRightRadius: '0.25rem',
};

/**
 * 폴더형 서류 만료일 알람 설정. 레거시와 같이 최대 3슬롯, 0이면 해제.
 */
const SubMatFolderAlarmSettingDialog = ({
  open,
  folderId,
  gclientId,
  alarms,
  onClose,
  onSaved,
}) => {
  const [slots, setSlots] = useState(EMPTY_SLOTS);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const { control } = useForm({ defaultValues: {} });

  useEffect(() => {
    if (!open) return undefined;
    setError('');
    const current = Array.isArray(alarms) ? alarms.filter((a) => a && a.period > 0) : [];
    const next = current.slice(0, 3).map((a) => ({
      period: a.period,
      type: a.type || 'D',
    }));
    while (next.length < 3) {
      next.push({ period: 0, type: 'D' });
    }
    setSlots(next);
    return undefined;
  }, [open, folderId, alarms]);

  const handleClose = () => {
    if (busy) return;
    onClose?.();
  };

  const handleChangePeriod = (e, index) => {
    const value = Number(e.target.value);
    const period = Number.isFinite(value) && value > 0 ? value : 0;
    setSlots((prev) => prev.map((slot, i) => (i === index ? { ...slot, period } : slot)));
  };

  const handleSubmit = async () => {
    if (!folderId) return;
    setBusy(true);
    setError('');
    try {
      await subMatFolderAlarmEmailActions.bulkCreateDirect({
        gclientId,
        folderId,
        subMatFolderAlarmEmails: slots.filter((slot) => slot.period > 0),
      });
      onSaved?.();
      onClose?.();
    } catch (e) {
      setError(e?.serverResponse?.message || e.message || '알람을 저장하지 못했습니다.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog
      open={Boolean(open)}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      aria-labelledby="submat-alarm-dialog-title"
      maxWidth="xs"
    >
      <DialogTitleClose
        id="submat-alarm-dialog-title"
        onClose={handleClose}
        style={{ cursor: 'move' }}
      >
        알람설정
      </DialogTitleClose>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ color: '#1976D2' }}>
            0을 설정하시면 알람이 꺼집니다.
          </Grid>
          {slots.map((slot, i) => (
            <Grid item xs={12} key={`alarm-slot-${i}`}>
              <Stack direction="row" display="flex" alignItems="center">
                <FormInputText
                  name={`period${i}`}
                  control={control}
                  value={slot.period}
                  type="number"
                  sx={{
                    'input[type=number]::-webkit-outer-spin-button': {
                      ...spinnerStyles,
                    },
                    'input[type=number]::-webkit-inner-spin-button': {
                      ...spinnerStyles,
                    },
                    width: '200px',
                    mr: 1,
                  }}
                  onChange={(e) => handleChangePeriod(e, i)}
                  InputProps={{
                    inputProps: {
                      style: { textAlign: 'center', marginLeft: '100px' },
                      min: 0,
                    },
                  }}
                />
                {slot.type === 'D' && '일 전'}
                {slot.type === 'W' && '주 전'}
                {slot.type === 'M' && '개월 전'}
              </Stack>
            </Grid>
          ))}
          {error && (
            <Grid item xs={12} sx={{ color: 'error.main', fontSize: '0.85rem' }}>
              {error}
            </Grid>
          )}
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleSubmit} disabled={busy || !folderId}>설정</Button>
        <Button onClick={handleClose} disabled={busy}>닫기</Button>
      </DialogActions>
    </Dialog>
  );
};

export default SubMatFolderAlarmSettingDialog;
